import React from 'react'
import { LoaderContainer, Spin } from '../theme'

function Loader(props) {
  return (
    <LoaderContainer>
      <Spin animation="grow" />
    </LoaderContainer>
  )
}

export default Loader
